import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ListCard, {
  ListCardNotDeduction,
  ListCardNotSetDeduction,
} from '../../../components/ListCard';
import Typography from '../../../components/common/Typography';
import { formatNumber, getTotal, nameRelation } from '../../../common/Util';
import { relationOptions } from '../../../common/data';

/*
c1 = parseInt(valueNumberCheck(v.htm025)) //신용카드 국세청
    +parseInt(valueNumberCheck(v.htm026)); //신용카드 국세청외

c2 = parseInt(valueNumberCheck(v.htm063)) //직불카드 국세청
    +parseInt(valueNumberCheck(v.htm064)); //직불카드 국세청외

c3 = parseInt(valueNumberCheck(v.htm027)); //현금영수증 국세청

c4 = parseInt(valueNumberCheck(v.htm116)) //제로페이 국세청
    +parseInt(valueNumberCheck(v.htm117)); //제로페이 국세청외

c5 = parseInt(valueNumberCheck(v.htm075)) //전통시장(1~3월) 국세청
    +parseInt(valueNumberCheck(v.htm076)); //전통시장(1~3월) 국세청외

c6 = parseInt(valueNumberCheck(v.htm092)) //전통시장(4~12월) 국세청
    +parseInt(valueNumberCheck(v.htm097)); //전통시장(4~12월) 국세청외

c7 = parseInt(valueNumberCheck(v.htm078)) //대중교통 국세청
    +parseInt(valueNumberCheck(v.htm079)); //대중교통 국세청외

c8 = parseInt(valueNumberCheck(v.htm112)); //도서공연-신용카드(1~3월)
c9 = parseInt(valueNumberCheck(v.htm113)); //도서공연-직불카드(1~3월)
c10 = parseInt(valueNumberCheck(v.htm114)); //도서공연-현금영수증(1~3월)
c11 = parseInt(valueNumberCheck(v.htm118)); //도서공연-제로페이(1~3월)

c12 = parseInt(valueNumberCheck(v.htm129)); //도서공연-신용카드(4~12월)
c13 = parseInt(valueNumberCheck(v.htm130)); //도서공연-직불카드(4~12월)
c14 = parseInt(valueNumberCheck(v.htm131)); //도서공연-현금영수증(4~12월)
c15 = parseInt(valueNumberCheck(v.htm132)); //도서공연-제로페이(4~12월)

c16 = parseInt(valueNumberCheck(v.htm054)) //신용기업경비
    +parseInt(valueNumberCheck(v.htm077)); //직불기업경비
*/

const CreditCardsItemSection = () => {
  const dispatch = useDispatch();
  const { t: tDependents } = useTranslation('dependents');
  const relationList = relationOptions(tDependents);
  const { dataList } = useSelector(state => state.creditCards);

  const content = (data, index, title) => {
    if (data.deType == '1') {
      return (
        <ListCard
          key={index}
          content={<ListCardContent data={data} title={title} />}
          isFirst={index === 0}
          detail={false}
          title="신용카드"
        />
      );
    }
    if (data.deType == '2') {
      return <ListCardNotDeduction title={title} key={index} />;
    }

    return <ListCardNotSetDeduction title={title} key={index} />;
  };

  return (
    <div>
      {dataList?.map((data, index) => {
        //이름 (관계)
        let title = nameRelation(tDependents, data);
        return content(data, index, title);
      })}
    </div>
  );
};

export default CreditCardsItemSection;

const ListCardContent = ({ data, title }) => {
  const { t } = useTranslation('deductions/creditcards');

  /* Htm084  전년도 신용카드 전체사용분(귀속년도-1)
      Htm085  전년도 직불카드 전체사용분(귀속년도-1)
      Htm086  전년도 현금영수증 전체사용분(귀속년도-1)
      Htm146  전년도 제로페이 전체사용분(귀속년도-1)
      Htm087  전년도 전통시장 사용분(귀속년도-1)
      Htm147  신용카드 전체사용분(귀속년도 재직기간 무관 전체)
      Htm148  직불카드 전체사용분(귀속년도 재직기간 무관 전체)
      Htm149  현금영수증 전체사용분(귀속년도 재직기간 무관 전체)
      Htm150  제로페이 전체사용분(귀속년도 재직기간 무관 전체)
      Htm153  전통시장 전체사용분(귀속년도 재직기간 무관 전체

     2025 수정
     htm025 : 신용카드 전체사용분
     htm063 : 직불카드 전체사용분
     htm027 : 현금영수증 전체사용분
     htm116 : 제로페이 전체사용분
     htm075 : 전통시장 전체사용분
     htm078 : 대중교통 전체사용분
     htm112 : 문화체육-신용카드
     htm113 : 문화체육-직불카드
     htm114 : 문화체육-현금영수증
     htm118 : 문화체육-제로페이


     htm026 : 신용카드 국세청외
     htm064 : 직불카드 국세청외
     htm117 : 제로페이 국세청외
     htm076 : 전통시장 국세청외
     htm079 : 대중교통 국세청외
   
     htm054 : 신용/직불기업경비
     htm077 : 신용/직불기업경비(국세청외)

*/

  console.log('data', data);

  return (
    <div className="p-4">
      <Typography variant="body2Bold">{title}</Typography>
      {/* 23년 전체사용분 / 24년 전체사용분 */}
      <Typography variant="captionMedium">
        {/* 2023{t('card.item3')}:{' '} */}
        {/* {formatNumber(getTotal([data], ['htm084', 'htm085', 'htm086', 'htm087', 'htm146']))} / */}
        {/* 2025{t('card.item3')}:{' '} */}
        {/* {formatNumber(getTotal([data], ['htm147', 'htm148', 'htm149', 'htm150', 'htm153']))} */}
      </Typography>

      {/* 신용카드, 직불카드 영역 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle1')}: {formatNumber(data?.htm025 || 0)} / {t('card.itemTitle2')}:{' '}
        {formatNumber(data?.htm063 || 0)}
      </Typography>

      {/* 현금영수증, 제로페이 영역 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle3')}: {formatNumber(data?.htm027 || 0)} / {t('card.itemTitle4')}:{' '}
        {formatNumber(data?.htm116 || 0)}
      </Typography>

      {/* 전통시장 / 대중교통 영역 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle5')}: {formatNumber(getTotal([data], ['htm075', 'htm076']))} /{' '}
        {t('card.itemTitle6')}: {formatNumber(getTotal([data], ['htm078', 'htm079']))}
      </Typography>

      {/* 문화체육 영역 신용카드, 직불카드  */}
      <Typography variant="captionMedium">
        {t('card.itemTitle7')} - {t('card.itemTitle1')}: {formatNumber(data?.htm112 || 0)} /{' '}
        {t('card.itemTitle2')}: {formatNumber(data?.htm113 || 0)}{' '}
      </Typography>

      {/* 문화체육 영역 현금영수증, 제로페이 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle7')} - {t('card.itemTitle3')}: {formatNumber(data?.htm114 || 0)} /{' '}
        {t('card.itemTitle4')}: {formatNumber(data?.htm118 || 0)}{' '}
      </Typography>

      {/* 도서공연 영역 (4~12월) */}
      {/* <Typography variant="captionMedium">
        {t('card.itemTitle7')} - {t('card.itemTitle1')}: {formatNumber(data?.htm007 || 0)} /{' '}
        {t('card.itemTitle2')}: {formatNumber(data?.htm007 || 0)}{' '}
      </Typography> */}

      {/* 도서공연 영역 (4~12월) - 현금영수증, 제로페이
      <Typography variant="captionMedium">
        {t('card.itemTitle7')} - {t('card.itemTitle3')}: {formatNumber(data?.htm007 || 0)} /{' '}
        {t('card.itemTitle4')}: {formatNumber(data?.htm007 || 0)}{' '}
      </Typography> */}

      {/* 신용/직불기업경비 영역 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle8')}: {formatNumber(getTotal([data], ['htm054', 'htm077']))}
      </Typography>
    </div>
  );
};
